import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'
import { Link, useParams } from 'react-router-dom';
import ExamContext from '../../context/Exam/ExamContext';
import InductionContext from '../../context/Induction/InductionContext';
import { EmployeeContext } from '../../context/Employee/EmployeeContext';
import { getUserDataByKey } from '../../helpers/helpers';
import { certificationGet } from '../../services/examService';

export const EmployeeDetailList = ({ employee, handleModalQuestionary, onShowCertificate, visualizationId }) => {

    const { id: instanceId, contractorId } = useParams()

    const { t } = useTranslation();

    // Sanitizar el employee_code para usar en IDs (reemplazar puntos y caracteres especiales)
    const sanitizeId = (code) => {
        return String(code).replace(/[.#]/g, '-');
    };

    const safeEmployeeCode = sanitizeId(employee.employee_code);

    const [loadingExam, setLoadingExam] = useState(false);
    const [examError, setExamError] = useState(false);

    const employeeExam = (questions, note) => {
        let questionaryCopy = { ...employee.questionary }
        questionaryCopy.questions = questions
        questionaryCopy.note = note
        questionaryCopy.employee = employee
        return questionaryCopy
    }

    const handleViewExam = async () => {
        if (!employee.exam?.certification) return;
        setLoadingExam(true);
        setExamError(false);
        const resp = await certificationGet(employee.exam.certification);
        setLoadingExam(false);
        if (resp?.ok && resp.data?.questionary) {
            handleModalQuestionary(employeeExam(resp.data.questionary.questions, resp.data.questionary.note));
        } else {
            // Sin toast en el panel: el icono pasa a estado de error y se puede reintentar
            setExamError(true);
        }
    }

    const { setExam, setVerify, resetEmployeeExam } = useContext(ExamContext);
    const { inductionState } = useContext(InductionContext);
    const { getDetail } = useContext(EmployeeContext);
    const { inductionSelected } = inductionState || {};

    const profile = getUserDataByKey('profile');
    // Obtener feedback del empleado (puede estar en employee.feedback o employee.exam.feedback)
    const employeeFeedback = employee.feedback || employee.exam?.feedback || '';

    const handleResetAttempts = async () => {
        if (resetEmployeeExam) {
            const success = await resetEmployeeExam({
                visualizationId: visualizationId,
                employeeId: employee.employee_id,
                contractorId: contractorId,
            });
            if (success) {
                getDetail(instanceId, contractorId);
            }
        }
    }


    return (
        <tr>
            <td>{employee.employee_name} <small>({employee.employee_code})</small></td>
            <td>{employee.employee_viewed ? t('common.yes') : t('common.no')}</td>
            <td>{(employee.exam && employee.employee_approved) ? t('common.yes') : (employee.exam && employee.employee_approved) ? t('common.no') : '-'}</td>
            <td>
                {
                    employee.exam ?
                        `${employee.exam.note}/${employee.questionary.max_score}` :
                        '-'
                }
            </td>
            <td>
                {
                    employee.exam
                        ?
                        employee.exam.attempts
                        :
                        '-'
                }
            </td>
            <td>{employee.date_from ? employee.date_from.slice(0, 10).split('-').reverse().join('-') : '-'}</td>
            <td>{employee.date_to ? employee.date_to.slice(0, 10).split('-').reverse().join('-') : '-'}</td>
            <td style={{ maxWidth: '300px', wordWrap: 'break-word' }}>
                {employeeFeedback ? (
                    <span title={employeeFeedback}>{employeeFeedback.length > 50 ? `${employeeFeedback.substring(0, 50)}...` : employeeFeedback}</span>
                ) : '-'}
            </td>
            <td>
                <div className="d-flex gap-3">
                    <div>
                        {/* Solo si hay certificacion: en un tenant sin migrar el
                            detalle no existe, y mostrar el icono seria un click muerto */}
                        {(employee.exam && employee.exam.certification) && (
                            <>
                                <CustomTooltip
                                    placement={"top"}
                                    target={`exam-detail-${safeEmployeeCode}`}
                                    text={examError ? t('common.error_server') : t('employee.view_exam')}
                                />
                                <i
                                    className={loadingExam
                                        ? "fa-solid fa-spinner fa-spin"
                                        : (examError ? "fa-solid fa-triangle-exclamation link-danger" : "fa-solid fa-clipboard-list")}
                                    id={`exam-detail-${safeEmployeeCode}`}
                                    type='button'
                                    onClick={loadingExam ? undefined : handleViewExam}
                                >
                                </i>
                            </>
                        )}
                    </div>
                    <div>
                        {(employee.exam && employee.employee_approved) && (
                            <>
                                <CustomTooltip
                                    placement={"top"}
                                    target={`certificate-detail-${safeEmployeeCode}`}
                                    text={t('employee.view_certificate')}
                                />

                                <i
                                    className="fa-solid fa-clipboard-check"
                                    id={`certificate-detail-${safeEmployeeCode}`}
                                    type='button'
                                    onClick={() => onShowCertificate(employee)}
                                >
                                </i>
                            </>
                        )}
                    </div>
                    <div>
                        {profile === '01' && !!employee.exam && employee.employee_approved === false && (
                            <>
                                <CustomTooltip
                                    placement={"top"}
                                    target={`reset-attempts-${safeEmployeeCode}`}
                                    text={t('employee.reset_attemps')}
                                />
                                <i
                                    className="fa-solid fa-rotate-left"
                                    id={`reset-attempts-${safeEmployeeCode}`}
                                    type='button'
                                    onClick={handleResetAttempts}
                                >
                                </i>
                            </>
                        )}
                    </div>
                </div>
            </td>
        </tr >
    )
}
